export default "__VITE_ASSET__6fe82f21__"